export const timezone = 'Europe/Oslo';
